import { render, staticRenderFns } from "./edit-sub-node.vue?vue&type=template&id=4b7dd638&scoped=true"
import script from "./edit-sub-node.vue?vue&type=script&lang=js"
export * from "./edit-sub-node.vue?vue&type=script&lang=js"
import style0 from "./edit-sub-node.vue?vue&type=style&index=0&id=4b7dd638&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b7dd638",
  null
  
)

export default component.exports